export interface TaskParametersResponse {
  conversationParameters: Record<string, { parameterId: string; name: string; value: string }>;
  templateParameters: Record<string, string>;
}

export enum Modality {
  Audio = 'Audio',
  IM = 'InstantMessaging',
  ExternalTask = 'ExternalTask',
  Email = 'Email',
}

export class CallerInfo {
  public displayName: string;
  public office365Id: string;
  public phoneNumber: string;
}

export class TaskFlowDetails {
  public serviceName: string;
  public servicePstnNumber?: string;
  public participantType: TaskFlowParticipantType;
  public consultationSessionId: string;
  public consultationType: ConsultationType;
  public teamId: string;
}

export enum TaskFlowParticipantType {
  Caller = 'Caller',
  IncomingCall = 'IncomingCall',
  Transfer = 'Transfer',
  ConsultationToUser = 'ConsultationToUser',
  ConsultationToService = 'ConsultationToService',
}

export enum ConsultationType {
  User = 'User',
  Service = 'Service',
  External = 'External',
}

export class ConversationCodesInfo {
  public currentPrimaryCode: string;
  public currentSecondaryCode: string;
  public tags: string[];
  public primaryCodeList: CodeInfo[];
  public secondaryCodeList: CodeInfo[];
  public codesAndTagsEnabled: boolean;
  /** Only stamped on Unify calls (`AcsCalling`); null means an Extend call. */
  public channel: Channel | null;
}

export class CodeInfo {
  public id: string;
  public name: string;
}

export enum CallDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  None = 'None',
}

export enum Channel {
  AcsCalling = 'AcsCalling',
  Interact = 'Interact',
  MsGraph = 'MsGraph',
  Outlook = 'Outlook',
  TwilioWhatsapp = 'TwilioWhatsapp',
  TwilioSms = 'TwilioSms',
  TwilioRcs = 'TwilioRcs',
}
